import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/beybies-ar/htdocs/ar.beybies.co/app/components/Comments.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/beybies-ar/htdocs/ar.beybies.co/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/beybies-ar/htdocs/ar.beybies.co/app/components/SinglePostContent.js");
;
import(/* webpackMode: "eager" */ "/home/beybies-ar/htdocs/ar.beybies.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/beybies-ar/htdocs/ar.beybies.co/node_modules/next/dist/client/image-component.js");
